module.exports = __webpack_public_path__ + "img/reddit-square.3330d589.svg";